// ─────────────────────────────────────────────────────────────────────────────
// Catalog
// ─────────────────────────────────────────────────────────────────────────────
// AUTO-GENERATED by inject-catalog.js — do not edit manually
const PRODUCTS = [
  {
    id: 1,
    name: "Stripe Shirt Set (0 - 3 m)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 380,
    mrp: 475,
    tag: "Bestseller",
    img: "/catalog/boys/1.jpg",
    bg: "linear-gradient(135deg,#ece6f4,#d5c9ec)",
    accent: "#9b8dc0",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "0-3M"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 2,
    name: "Block Kurta Set (0 - 3 m)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 450,
    mrp: 563,
    tag: "New",
    img: "/catalog/boys/2.jpg",
    bg: "linear-gradient(135deg,#fde9b0,#f5c842)",
    accent: "#c89b1a",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "0-3M"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 3,
    name: "Linen Shorts (0 - 3 m)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 480,
    mrp: 600,
    tag: null,
    img: "/catalog/boys/3.jpg",
    bg: "linear-gradient(135deg,#d4eaf5,#a8d4ea)",
    accent: "#5a9ec0",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "0-3M"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 4,
    name: "Print Tee Set (0-1 yr)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 800,
    mrp: 1000,
    tag: null,
    img: "/catalog/boys/4.jpg",
    bg: "linear-gradient(135deg,#f8f4ef,#ebe4d8)",
    accent: "#a09080",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "0-1Y"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 5,
    name: "Stripe Shirt Set (0-1 yr)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 950,
    mrp: 1188,
    tag: null,
    img: "/catalog/boys/5.jpg",
    bg: "linear-gradient(135deg,#b8eae0,#7dd8cc)",
    accent: "#3a9e94",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "0-1Y"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 6,
    name: "Block Kurta Set (1 - 2 yr)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 500,
    mrp: 625,
    tag: null,
    img: "/catalog/boys/6.jpg",
    bg: "linear-gradient(135deg,#fde0d0,#f0b89a)",
    accent: "#d4785a",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "1-2Y"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 7,
    name: "Linen Shorts (1 - 2 yr)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 650,
    mrp: 813,
    tag: null,
    img: "/catalog/boys/7.jpg",
    bg: "linear-gradient(135deg,#d8e8d0,#a8c89c)",
    accent: "#5a8040",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "1-2Y"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 8,
    name: "Print Tee Set (2 - 3)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 800,
    mrp: 1000,
    tag: null,
    img: "/catalog/boys/8.jpg",
    bg: "linear-gradient(135deg,#c8d4e8,#8090b8)",
    accent: "#4060a0",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "2-3Y"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 9,
    name: "Stripe Shirt Set (2 - 3)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 950,
    mrp: 1188,
    tag: null,
    img: "/catalog/boys/9.jpg",
    bg: "linear-gradient(135deg,#f5e0e8,#e8b8c8)",
    accent: "#c06080",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "2-3Y"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 10,
    name: "Block Kurta Set (3 - 6 m)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 650,
    mrp: 813,
    tag: null,
    img: "/catalog/boys/10.jpg",
    bg: "linear-gradient(135deg,#e8f0d8,#c8dca8)",
    accent: "#6a9040",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "3-6M"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 11,
    name: "Linen Shorts (3 - 6 m)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 380,
    mrp: 475,
    tag: null,
    img: "/catalog/boys/11.jpg",
    bg: "linear-gradient(135deg,#ece6f4,#d5c9ec)",
    accent: "#9b8dc0",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "3-6M"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 12,
    name: "Print Tee Set (3 - 6 m)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 450,
    mrp: 563,
    tag: null,
    img: "/catalog/boys/12.jpg",
    bg: "linear-gradient(135deg,#fde9b0,#f5c842)",
    accent: "#c89b1a",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "3-6M"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 13,
    name: "Stripe Shirt Set (3 - 6 m)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 480,
    mrp: 600,
    tag: null,
    img: "/catalog/boys/13.jpg",
    bg: "linear-gradient(135deg,#d4eaf5,#a8d4ea)",
    accent: "#5a9ec0",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "3-6M"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 14,
    name: "Block Kurta Set (3 -4)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 900,
    mrp: 1125,
    tag: null,
    img: "/catalog/boys/14.jpg",
    bg: "linear-gradient(135deg,#f8f4ef,#ebe4d8)",
    accent: "#a09080",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "3-4Y"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 15,
    name: "Linen Shorts (6 - 12 m)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 650,
    mrp: 813,
    tag: null,
    img: "/catalog/boys/15.jpg",
    bg: "linear-gradient(135deg,#b8eae0,#7dd8cc)",
    accent: "#3a9e94",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "6-12M"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 16,
    name: "Print Tee Set (9 - 12m)",
    subtitle: "Boys",
    category: "Boys",
    sub: "Boys",
    price: 650,
    mrp: 813,
    tag: null,
    img: "/catalog/boys/16.jpg",
    bg: "linear-gradient(135deg,#fde0d0,#f0b89a)",
    accent: "#d4785a",
    emoji: "🌿",
    color: "Boys",
    sizes: [
      "9-12M"
    ],
    desc: "Easy-wear cotton set. Neat enough for events, comfortable for play.",
    badge: "Boys"
  },
  {
    id: 17,
    name: "Cotton Frock (0 - 1 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 800,
    mrp: 1000,
    tag: null,
    img: "/catalog/girls/17.jpg",
    bg: "linear-gradient(135deg,#d8e8d0,#a8c89c)",
    accent: "#5a8040",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "0-1Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 18,
    name: "Coord Set (0 - 1 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 950,
    mrp: 1188,
    tag: null,
    img: "/catalog/girls/18.jpg",
    bg: "linear-gradient(135deg,#c8d4e8,#8090b8)",
    accent: "#4060a0",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "0-1Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 19,
    name: "Pinafore Dress (0 - 3 m)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 450,
    mrp: 563,
    tag: null,
    img: "/catalog/girls/19.jpg",
    bg: "linear-gradient(135deg,#f5e0e8,#e8b8c8)",
    accent: "#c06080",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "0-3M"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 20,
    name: "Midi Dress (0 - 3 m)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 650,
    mrp: 813,
    tag: null,
    img: "/catalog/girls/20.jpg",
    bg: "linear-gradient(135deg,#e8f0d8,#c8dca8)",
    accent: "#6a9040",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "0-3M"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 21,
    name: "Embroidered Frock (0 - 3 m)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 350,
    mrp: 438,
    tag: null,
    img: "/catalog/girls/21.jpg",
    bg: "linear-gradient(135deg,#ece6f4,#d5c9ec)",
    accent: "#9b8dc0",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "0-3M"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 22,
    name: "Cotton Frock (1 - 2 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1200,
    mrp: 1500,
    tag: null,
    img: "/catalog/girls/22.jpg",
    bg: "linear-gradient(135deg,#fde9b0,#f5c842)",
    accent: "#c89b1a",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "1-2Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 23,
    name: "Coord Set (1 - 2 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1250,
    mrp: 1563,
    tag: null,
    img: "/catalog/girls/23.jpg",
    bg: "linear-gradient(135deg,#d4eaf5,#a8d4ea)",
    accent: "#5a9ec0",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "1-2Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 24,
    name: "Pinafore Dress (1 - 2 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1450,
    mrp: 1813,
    tag: null,
    img: "/catalog/girls/24.jpg",
    bg: "linear-gradient(135deg,#f8f4ef,#ebe4d8)",
    accent: "#a09080",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "1-2Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 25,
    name: "Midi Dress (1 - 2 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 650,
    mrp: 813,
    tag: null,
    img: "/catalog/girls/25.jpg",
    bg: "linear-gradient(135deg,#b8eae0,#7dd8cc)",
    accent: "#3a9e94",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "1-2Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 26,
    name: "Embroidered Frock (1 - 2 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 750,
    mrp: 938,
    tag: null,
    img: "/catalog/girls/26.jpeg",
    bg: "linear-gradient(135deg,#fde0d0,#f0b89a)",
    accent: "#d4785a",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "1-2Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 27,
    name: "Cotton Frock (2 - 3 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1200,
    mrp: 1500,
    tag: null,
    img: "/catalog/girls/27.jpg",
    bg: "linear-gradient(135deg,#d8e8d0,#a8c89c)",
    accent: "#5a8040",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "2-3Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 28,
    name: "Coord Set (2 - 3 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1300,
    mrp: 1625,
    tag: null,
    img: "/catalog/girls/28.jpg",
    bg: "linear-gradient(135deg,#c8d4e8,#8090b8)",
    accent: "#4060a0",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "2-3Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 29,
    name: "Pinafore Dress (2 - 3 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1350,
    mrp: 1688,
    tag: null,
    img: "/catalog/girls/29.jpg",
    bg: "linear-gradient(135deg,#f5e0e8,#e8b8c8)",
    accent: "#c06080",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "2-3Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 30,
    name: "Midi Dress (2 - 3 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1450,
    mrp: 1813,
    tag: null,
    img: "/catalog/girls/30.jpg",
    bg: "linear-gradient(135deg,#e8f0d8,#c8dca8)",
    accent: "#6a9040",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "2-3Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 31,
    name: "Embroidered Frock (2 - 3 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1500,
    mrp: 1875,
    tag: null,
    img: "/catalog/girls/31.jpg",
    bg: "linear-gradient(135deg,#ece6f4,#d5c9ec)",
    accent: "#9b8dc0",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "2-3Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 32,
    name: "Cotton Frock (2 - 3 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 800,
    mrp: 1000,
    tag: null,
    img: "/catalog/girls/32.jpg",
    bg: "linear-gradient(135deg,#fde9b0,#f5c842)",
    accent: "#c89b1a",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "2-3Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 33,
    name: "Coord Set (2 - 3 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1250,
    mrp: 1563,
    tag: null,
    img: "/catalog/girls/33.jpg",
    bg: "linear-gradient(135deg,#d4eaf5,#a8d4ea)",
    accent: "#5a9ec0",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "2-3Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 34,
    name: "Pinafore Dress (2 - 3 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1400,
    mrp: 1750,
    tag: null,
    img: "/catalog/girls/34.jpg",
    bg: "linear-gradient(135deg,#f8f4ef,#ebe4d8)",
    accent: "#a09080",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "2-3Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 35,
    name: "Midi Dress (2 - 3 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 650,
    mrp: 813,
    tag: null,
    img: "/catalog/girls/35.jpg",
    bg: "linear-gradient(135deg,#b8eae0,#7dd8cc)",
    accent: "#3a9e94",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "2-3Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 36,
    name: "Embroidered Frock (2 - 3 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 750,
    mrp: 938,
    tag: null,
    img: "/catalog/girls/36.jpg",
    bg: "linear-gradient(135deg,#fde0d0,#f0b89a)",
    accent: "#d4785a",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "2-3Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 37,
    name: "Cotton Frock (3 - 4 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1200,
    mrp: 1500,
    tag: null,
    img: "/catalog/girls/37.jpg",
    bg: "linear-gradient(135deg,#d8e8d0,#a8c89c)",
    accent: "#5a8040",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "3-4Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 38,
    name: "Coord Set (3 - 4 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1450,
    mrp: 1813,
    tag: null,
    img: "/catalog/girls/38.jpg",
    bg: "linear-gradient(135deg,#c8d4e8,#8090b8)",
    accent: "#4060a0",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "3-4Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 39,
    name: "Pinafore Dress (3 - 4 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1500,
    mrp: 1875,
    tag: null,
    img: "/catalog/girls/39.jpg",
    bg: "linear-gradient(135deg,#f5e0e8,#e8b8c8)",
    accent: "#c06080",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "3-4Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 40,
    name: "Midi Dress (3 - 4 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 750,
    mrp: 938,
    tag: null,
    img: "/catalog/girls/40.jpg",
    bg: "linear-gradient(135deg,#e8f0d8,#c8dca8)",
    accent: "#6a9040",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "3-4Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 41,
    name: "Embroidered Frock (3 - 8 m)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 650,
    mrp: 813,
    tag: null,
    img: "/catalog/girls/41.jpg",
    bg: "linear-gradient(135deg,#ece6f4,#d5c9ec)",
    accent: "#9b8dc0",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "3-8M"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 42,
    name: "Cotton Frock (3 - 8 m)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 850,
    mrp: 1063,
    tag: null,
    img: "/catalog/girls/42.jpg",
    bg: "linear-gradient(135deg,#fde9b0,#f5c842)",
    accent: "#c89b1a",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "3-8M"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 43,
    name: "Coord Set (4 - 5 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1100,
    mrp: 1375,
    tag: null,
    img: "/catalog/girls/43.jpg",
    bg: "linear-gradient(135deg,#d4eaf5,#a8d4ea)",
    accent: "#5a9ec0",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "4-5Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 44,
    name: "Pinafore Dress (4 - 5 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1150,
    mrp: 1438,
    tag: null,
    img: "/catalog/girls/44.jpg",
    bg: "linear-gradient(135deg,#f8f4ef,#ebe4d8)",
    accent: "#a09080",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "4-5Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 45,
    name: "Midi Dress (4 - 5 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1400,
    mrp: 1750,
    tag: null,
    img: "/catalog/girls/45.jpg",
    bg: "linear-gradient(135deg,#b8eae0,#7dd8cc)",
    accent: "#3a9e94",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "4-5Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 46,
    name: "Embroidered Frock (4 - 5 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1450,
    mrp: 1813,
    tag: null,
    img: "/catalog/girls/46.jpg",
    bg: "linear-gradient(135deg,#fde0d0,#f0b89a)",
    accent: "#d4785a",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "4-5Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 47,
    name: "Cotton Frock (4 - 5 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1500,
    mrp: 1875,
    tag: null,
    img: "/catalog/girls/47.jpg",
    bg: "linear-gradient(135deg,#d8e8d0,#a8c89c)",
    accent: "#5a8040",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "4-5Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 48,
    name: "Coord Set (5 - 6 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1400,
    mrp: 1750,
    tag: null,
    img: "/catalog/girls/48.jpg",
    bg: "linear-gradient(135deg,#c8d4e8,#8090b8)",
    accent: "#4060a0",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "5-6Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 49,
    name: "Pinafore Dress (5 - 6 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1450,
    mrp: 1813,
    tag: null,
    img: "/catalog/girls/49.jpg",
    bg: "linear-gradient(135deg,#f5e0e8,#e8b8c8)",
    accent: "#c06080",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "5-6Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 50,
    name: "Midi Dress (5 - 6 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1550,
    mrp: 1938,
    tag: null,
    img: "/catalog/girls/50.png",
    bg: "linear-gradient(135deg,#e8f0d8,#c8dca8)",
    accent: "#6a9040",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "5-6Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 51,
    name: "Embroidered Frock (5 - 6 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 900,
    mrp: 1125,
    tag: null,
    img: "/catalog/girls/51.jpg",
    bg: "linear-gradient(135deg,#ece6f4,#d5c9ec)",
    accent: "#9b8dc0",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "5-6Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 52,
    name: "Cotton Frock (6 - 12 m)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1200,
    mrp: 1500,
    tag: null,
    img: "/catalog/girls/52.jpg",
    bg: "linear-gradient(135deg,#fde9b0,#f5c842)",
    accent: "#c89b1a",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "6-12M"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 53,
    name: "Coord Set (6 - 12 m)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1600,
    mrp: 2000,
    tag: null,
    img: "/catalog/girls/53.jpg",
    bg: "linear-gradient(135deg,#d4eaf5,#a8d4ea)",
    accent: "#5a9ec0",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "6-12M"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 54,
    name: "Pinafore Dress (6 - 12 m)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 650,
    mrp: 813,
    tag: null,
    img: "/catalog/girls/54.jpg",
    bg: "linear-gradient(135deg,#f8f4ef,#ebe4d8)",
    accent: "#a09080",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "6-12M"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 55,
    name: "Midi Dress (6 - 12 m)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 700,
    mrp: 875,
    tag: null,
    img: "/catalog/girls/55.jpg",
    bg: "linear-gradient(135deg,#b8eae0,#7dd8cc)",
    accent: "#3a9e94",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "6-12M"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 56,
    name: "Embroidered Frock (6 - 12 m)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 750,
    mrp: 938,
    tag: null,
    img: "/catalog/girls/56.jpg",
    bg: "linear-gradient(135deg,#fde0d0,#f0b89a)",
    accent: "#d4785a",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "6-12M"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 57,
    name: "Cotton Frock (6 - 12 m)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 800,
    mrp: 1000,
    tag: null,
    img: "/catalog/girls/57.jpg",
    bg: "linear-gradient(135deg,#d8e8d0,#a8c89c)",
    accent: "#5a8040",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "6-12M"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 58,
    name: "Coord Set (6 - 7 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 1550,
    mrp: 1938,
    tag: null,
    img: "/catalog/girls/58.jpg",
    bg: "linear-gradient(135deg,#c8d4e8,#8090b8)",
    accent: "#4060a0",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "6-7Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 59,
    name: "Pinafore Dress (6 - 7 y)",
    subtitle: "Girls",
    category: "Girls",
    sub: "Girls",
    price: 950,
    mrp: 1188,
    tag: null,
    img: "/catalog/girls/59.jpg",
    bg: "linear-gradient(135deg,#f5e0e8,#e8b8c8)",
    accent: "#c06080",
    emoji: "🌸",
    color: "Girls",
    sizes: [
      "6-7Y"
    ],
    desc: "Pure cotton dress, curated by Prajakta. Gets softer with every wash.",
    badge: "Girls"
  },
  {
    id: 60,
    name: "Newborn Jabla \u2014 Newborn",
    subtitle: "Newborn",
    category: "Baby",
    sub: "Newborn",
    price: 450,
    mrp: 563,
    tag: null,
    img: "/catalog/newborn/60.jpg",
    bg: "linear-gradient(135deg,#e8f0d8,#c8dca8)",
    accent: "#6a9040",
    emoji: "\uD83D\uDC76",
    color: "Newborn",
    sizes: [
      "0-3M",
      "3-6M",
      "6-12M",
      "1-2Y"
    ],
    desc: "Ultra-soft 100% cotton, gentle on newborn skin. Perfect first outfit.",
    badge: "Baby"
  },
  {
    id: 61,
    name: "Newborn Set \u2014 Newborn",
    subtitle: "Newborn",
    category: "Baby",
    sub: "Newborn",
    price: 480,
    mrp: 600,
    tag: null,
    img: "/catalog/newborn/61.jpg",
    bg: "linear-gradient(135deg,#ece6f4,#d5c9ec)",
    accent: "#9b8dc0",
    emoji: "\uD83D\uDC76",
    color: "Newborn",
    sizes: [
      "0-3M",
      "3-6M",
      "6-12M",
      "1-2Y"
    ],
    desc: "Ultra-soft 100% cotton, gentle on newborn skin. Perfect first outfit.",
    badge: "Baby"
  },
  {
    id: 62,
    name: "Infant Outfit \u2014 Newborn",
    subtitle: "Newborn",
    category: "Baby",
    sub: "Newborn",
    price: 380,
    mrp: 475,
    tag: null,
    img: "/catalog/newborn/62.jpg",
    bg: "linear-gradient(135deg,#fde9b0,#f5c842)",
    accent: "#c89b1a",
    emoji: "\uD83D\uDC76",
    color: "Newborn",
    sizes: [
      "0-3M",
      "3-6M",
      "6-12M",
      "1-2Y"
    ],
    desc: "Ultra-soft 100% cotton, gentle on newborn skin. Perfect first outfit.",
    badge: "Baby"
  },
  {
    id: 63,
    name: "Cotton Swaddle \u2014 Swaddles",
    subtitle: "Swaddles",
    category: "Baby",
    sub: "Swaddles",
    price: 500,
    mrp: 625,
    tag: null,
    img: "/catalog/swaddles/63.jpg",
    bg: "linear-gradient(135deg,#d4eaf5,#a8d4ea)",
    accent: "#5a9ec0",
    emoji: "\uD83E\uDDF8",
    color: "Swaddles",
    sizes: [
      "0-3M",
      "3-6M",
      "6-12M",
      "1-2Y"
    ],
    desc: "Breathable mulmul cotton swaddle. Keeps baby snug and comfortable.",
    badge: "Baby"
  }
];

export default PRODUCTS;
